'use client';

import { useTranslations } from 'next-intl';
import {
  AssetsApiTypeSchema,
  type AssetsApiTypeDto,
} from '@terra/shared-contracts-assets';
import { Filter } from '@terra/ui-design-system';

const API_TYPE_FILTER_ITEMS = AssetsApiTypeSchema.options.map((apiType) => ({
  value: apiType,
  label: apiType,
}));

export function AssetsApiTypeFilter({
  value,
  onValueChange,
}: {
  value: AssetsApiTypeDto[];
  onValueChange: (apiTypes: AssetsApiTypeDto[]) => void;
}) {
  const t = useTranslations('proxy.assets.filters');

  return (
    <Filter
      id="api-type"
      density="compact"
      isMultiSelect
      placeholder={t('type')}
      items={API_TYPE_FILTER_ITEMS}
      value={value}
      onChange={(values) =>
        onValueChange(
          AssetsApiTypeSchema.options.filter((apiType) =>
            values.includes(apiType),
          ),
        )
      }
    />
  );
}
